import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'admin-portal-date-picker',
  templateUrl:
    './console/app-js/shared/components/admin-portal-date-picker/admin-portal-date-picker.component.html'
})
export class AdminPortalDatePickerComponent implements OnInit {
  /*
   * Date view modes and format
   */
  private readonly DATE_BOTTOM_VIEW = 'month';
  private readonly DATE_TOP_VIEW = 'year';
  private readonly DATE_FORMAT = 'MM-dd-yyyy';

  /*
   * Year view modes and format
   */
  private readonly YEAR_BOTTOM_VIEW = 'decade';
  private readonly YEAR_TOP_VIEW = 'decade';
  private readonly YEAR_FORMAT = 'yyyy';

  @Input('mode') mode: AdminPortalDatePickerModes =
    AdminPortalDatePickerModes.DATE;
  @Input('model') model: any;
  @Output('modelChange') modelChange = new EventEmitter<any>();
  @Input('class') class: string;
  protected bottomView = this.DATE_BOTTOM_VIEW;
  protected topView = this.DATE_TOP_VIEW;
  protected format = this.DATE_FORMAT;

  constructor() {
    // Silence is golden.
  }

  ngOnInit(): void {
    if (this.mode === AdminPortalDatePickerModes.YEAR) {
      this.bottomView = this.YEAR_BOTTOM_VIEW;
      this.topView = this.YEAR_TOP_VIEW;
      this.format = this.YEAR_FORMAT;
    }
  }

  /**
   * On Date selected close selector.
   */
  protected onModelChange($event): void {
    this.modelChange.emit($event);
  }
}

export enum AdminPortalDatePickerModes {
  YEAR,
  DATE,
  DATETIME
}
